import Vue from 'vue'
import App from './App.vue'
import messages from "./language"
import VueI18n from 'vue-i18n';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI, { locale })

Vue.use(VueI18n);

Vue.config.productionTip = false

// 创建 I18n 实例
const i18n = new VueI18n({
  locale: 'en', // 默认语言
  messages,     // 语言包
});

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app')
